import * as _ from 'lodash';
import { Branch } from 'models';
import { AbstractControl } from '@angular/forms';

export const glnPattern = /^[0-9]{13}$/;

export const shortNameUniquenessValidator =
    (stores: Branch[], gln?: string) => (shortNameFormControl: AbstractControl) => {
        const shortName = _.toString(shortNameFormControl.value);
        if (!shortName) {
            return null;
        }

        const isAvailableShortName = !stores
            .filter((store) => store?.address?.gln !== gln)
            .find((store) => store?.shortName?.toLowerCase() === shortName.toLowerCase());

        return isAvailableShortName ? null : { existingShortName: { value: shortNameFormControl.value } };
    };
